import { Search, MessageSquare } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { SearchResult } from "@/lib/api/admin";
import { MentorshipDetails } from "@/lib/api/mentorships";
import { SearchResultItem } from "./search-result-item";

interface SearchResultsProps {
  results: SearchResult[];
  totalCount: number;
  searchQuery: string;
  mentorship: MentorshipDetails;
  onViewContext: (messageId: number) => void;
}

export function SearchResults({
  results,
  totalCount,
  searchQuery,
  mentorship,
  onViewContext,
}: SearchResultsProps) {
  return (
    <Card className="border-0 shadow-lg">
      <CardHeader className="border-b border-gray-100 bg-gray-50/50">
        <CardTitle className="flex items-center gap-3">
          <div className="rounded-lg bg-green-100 p-2">
            <MessageSquare className="h-5 w-5 text-green-600" />
          </div>
          <div>
            <div className="text-lg font-semibold text-gray-900">
              Search Results
            </div>
            <div className="text-sm font-normal text-gray-600">
              {totalCount} message{totalCount !== 1 ? "s" : ""} found
              {searchQuery && (
                <span className="ml-1">
                  for &ldquo;
                  <span className="font-medium">{searchQuery}</span>&rdquo;
                </span>
              )}
            </div>
          </div>
        </CardTitle>
      </CardHeader>
      <CardContent className="p-2">
        {results.length === 0 ? (
          <div className="py-12 text-center">
            <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-gray-100 p-4">
              <Search className="h-8 w-8 text-gray-400" />
            </div>
            <p className="text-lg font-medium text-gray-500">
              No messages found
            </p>
            <p className="mt-1 text-sm text-gray-400">
              Try adjusting your search terms or filters
            </p>
          </div>
        ) : (
          <div className="space-y-4">
            {results.map((result) => (
              <SearchResultItem
                key={result.message_id}
                result={result}
                mentorship={mentorship}
                searchQuery={searchQuery}
                onViewContext={onViewContext}
              />
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
